export const SELECTED_UNIT_NUMBER_KEY = "SelectedUnitNumber";
export const AUTH_TOKEN_KEY = "AuthToken";
export const PURCHASE_OFFER_KEY = "PurchaseOfferId";

export const checkIfInLocalStorage = (key: string): boolean => {
  if (typeof window === "undefined") {
    return undefined;
  }

  return localStorage.getItem(key) !== null;
};

export const getFromLocalStorage = (key: string): string | undefined => {
  if (typeof window === "undefined") {
    return undefined;
  }

  const value = localStorage.getItem(key);

  return value === null ? undefined : value;
};

export const getFromLocalStorageOrThrow = (key: string): string => {
  if (typeof window === "undefined") {
    console.log(
      `${key} not found in local storage because code running on server`
    );
    throw new Error(`${key} not found in because code running on server`);
  }

  let value = localStorage.getItem(key);

  if (!value) {
    console.log(`${key} not found in local storage`);
    throw new Error(`${key} not found in local storage`);
  }
  return value;
};

export const getObjFromStorageOrDefault = <TReturn>(
  key: string,
  d: TReturn
): TReturn => {
  if (typeof window === "undefined") {
    return d;
  }

  const storedStateString = localStorage?.getItem(key);

  return storedStateString ? (JSON.parse(storedStateString) as TReturn) : d;
};

export const removeItemIfExists = <TReturn>(key: string): TReturn => {
  if (typeof window === "undefined") {
    return;
  }

  localStorage.removeItem(key);
};

export const setItemIfItExists = <TReturn>(
  key: string,
  val: string,
  d: TReturn
): TReturn => {
  if (typeof window === "undefined") {
    return d;
  }

  localStorage.setItem(key, val);
};

export const getStringFromStorageOrDefault = (key: string) => {
  if (typeof window === "undefined") {
    return null;
  }

  const storedStateString = window.localStorage.getItem(key);

  return storedStateString ? storedStateString : null;
};
